/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-02-24 17:50:29
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import MHead from "../../../../../components/MHead";
import { Tabs } from 'antd';
import CaseItem from "./CaseItem";
import { queryCaseApi, queryCaseTypeApi } from "../../../WebService";
import HttpUtils from "../../../../../utils/HttpUtils";

const Case = ({ dispatch, router }) => {

  const [activeKey, setActiveKey] = useState('0')

  useEffect(() => {
    init()
  }, [])

  const [caseTypes, setCaseTypes] = useState([])
  const [caseList, setCaseList] = useState([])


  const init = () => {
    HttpUtils.post(
      queryCaseTypeApi,
      {},
      (res) => {
        setCaseTypes(res.data)
      }
    )
  }

  useEffect(() => {
    queryCase()
  }, [activeKey])


  const queryCase = () => {
    HttpUtils.post(
      queryCaseApi,
      {
        currentPage: 1,
        pageSize: 10,
        caseTypeId: activeKey
      },
      (res) => {
        setCaseList(res.data)
      }
    )
  }



  return (
    <div className="Case">
      <MHead router={router} />
      <div className="CaseContent">
        <Tabs
          activeKey={activeKey}
          onChange={(key) => {
            setActiveKey(key)
          }}
        >
          <Tabs.TabPane
            tab='全部'
            key={'0'}
          ></Tabs.TabPane>
          {
            caseTypes.map(item => {
              return (
                <Tabs.TabPane tab={item.typeName} key={item.id}>
                </Tabs.TabPane>
              )
            })
          }
        </Tabs>
        <div className="caseItemList">
          {
            caseList && caseList.length > 0 &&
            caseList.map((item, index) => {
              return (
                <CaseItem item={item} key={index} caseTypes={caseTypes} />
              )
            })
          }
        </div>
      </div>

    </div>
  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(Case);
